import React, { useState } from 'react';
import { Glyphicon, Modal } from 'react-bootstrap'
import { Tooltip } from '../Tooltip/Tooltip';

import "./HelpIcon.scss";

export enum HelpIconMode {
    Tooltip,
    Modal
}

export interface HelpIconProps {    
    title?: string;    
    mode?: HelpIconMode
};

export const HelpIcon: React.FC<HelpIconProps> = (props) => {    
    const icon = <Glyphicon glyph="question-sign" className="cs-help-icon"></Glyphicon>;
    const mode = props.mode || HelpIconMode.Tooltip;
    const content = props.children as JSX.Element;

    const [showModal, setShowModal] = useState<boolean>(false);

    const handleShow = () => setShowModal(true);
    const handleHide = () => setShowModal(false);

    switch (mode) {
        case HelpIconMode.Tooltip:
                return (
                    <Tooltip message={props.children} placement="top" requiresMessage={true}>
                        {icon}
                    </Tooltip>
                )
        case HelpIconMode.Modal:
                return (
                    <>
                        <span onClick={handleShow}>{icon}</span>                
                        <Modal show={showModal} onHide={handleHide}>
                            <Modal.Header closeButton>{props.title || "Help"}</Modal.Header>
                            <Modal.Body>{props.children}</Modal.Body>                    
                        </Modal>
                    </>
                )   
        default:
            return icon;

    }    
}

(HelpIcon as any).displayName = "HelpIcon";